import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "risk" }
const _hoisted_2 = { class: "record-info" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "audio" }
const _hoisted_5 = { class: "cantonese-audio" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "timer" }
const _hoisted_8 = { class: "cantonese-audio" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "timer" }
const _hoisted_11 = { class: "introduce" }
const _hoisted_12 = { class: "agree" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 2,
    isDisabled: _ctx.isDisabled,
    prePathName: "tax-info"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title" }, "风险披露", -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "avatar" }, [
            _createElementVNode("i")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "name" }, "持牌代表：YAN Yuen Cheung", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "number" }, "牌照号：BPV918", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("audio", {
                  ref: "cantoneseEl",
                  src: _ctx.cantonese.url
                }, null, 8, _hoisted_6),
                _createElementVNode("i", {
                  class: _normalizeClass(`iconfont ${!_ctx.cantonese.status ? 'icon-bofang' : 'icon-ai05'}`),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeCantonesePlay && _ctx.changeCantonesePlay(...args)))
                }, null, 2),
                _cache[5] || (_cache[5] = _createElementVNode("p", null, "粤语", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_van_count_down, {
                    ref: "cantoneseCountEl",
                    class: "timer-count",
                    "auto-start": _ctx.cantoneseAutoStart,
                    format: "mm:ss",
                    onFinish: _ctx.finish,
                    time: _ctx.cantoneseTime
                  }, null, 8, ["auto-start", "onFinish", "time"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("audio", {
                  ref: "mandarinEl",
                  src: _ctx.mandarin.url
                }, null, 8, _hoisted_9),
                _createElementVNode("i", {
                  class: _normalizeClass(`iconfont ${!_ctx.mandarin.status ? 'icon-bofang' : 'icon-ai05'}`),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeMandarinPlay && _ctx.changeMandarinPlay(...args)))
                }, null, 2),
                _cache[6] || (_cache[6] = _createElementVNode("p", null, "普通话", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_van_count_down, {
                    ref: "mandarinCountEl",
                    class: "timer-count",
                    "auto-start": _ctx.mandarinAutoStart,
                    format: "mm:ss",
                    onFinish: _ctx.finish,
                    time: _ctx.mandarinTime
                  }, null, 8, ["auto-start", "onFinish", "time"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RISK_CONTENT, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "introduce-item"
            }, [
              _createElementVNode("div", null, _toDisplayString(item.label), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_van_field, {
            name: "agree",
            rules: [{ required: true, message: '请同意以上条款' }]
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_checkbox, {
                modelValue: _ctx.riskChecked,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.riskChecked) = $event)),
                shape: "square"
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(
                    `iconfont ${_ctx.riskChecked ? 'icon-duoxuanxuanzhong' : 'icon-duoxuanweixuanzhong'}`
                  )
                  }, null, 2)
                ]),
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createTextVNode(" 本人完全细阅、同意、确认、接受、明白及愿意遵守 ")),
                  _createElementVNode("span", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toClient && _ctx.toClient(...args)), ["stop"]))
                  }, "《客户声明》"),
                  _cache[11] || (_cache[11] = _createTextVNode(" 及以上")),
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toRisk && _ctx.toRisk(...args)), ["stop"]))
                  }, "《风险披露声明》")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled"]))
}